export const PhysicalHealthRaw = [
  { Physical_raw_score: 4, Physical_SummedScore: 16.2, Physical_T_Score: 4.8 },
  { Physical_raw_score: 5, Physical_SummedScore: 19.9, Physical_T_Score: 4.7 },
  { Physical_raw_score: 6, Physical_SummedScore: 23.5, Physical_T_Score: 4.5 },
  { Physical_raw_score: 7, Physical_SummedScore: 26.7, Physical_T_Score: 4.3 },
  { Physical_raw_score: 8, Physical_SummedScore: 29.6, Physical_T_Score: 4.2 },
  { Physical_raw_score: 9, Physical_SummedScore: 32.4, Physical_T_Score: 4.2 },
  { Physical_raw_score: 10, Physical_SummedScore: 34.9, Physical_T_Score: 4.1 },
  { Physical_raw_score: 11, Physical_SummedScore: 37.4, Physical_T_Score: 4.1 },
  { Physical_raw_score: 12, Physical_SummedScore: 39.8, Physical_T_Score: 4.1 },
  { Physical_raw_score: 13, Physical_SummedScore: 42.3, Physical_T_Score: 4.2 },
  { Physical_raw_score: 14, Physical_SummedScore: 44.9, Physical_T_Score: 4.3 },
  { Physical_raw_score: 15, Physical_SummedScore: 47.7, Physical_T_Score: 4.4 },
  { Physical_raw_score: 16, Physical_SummedScore: 50.8, Physical_T_Score: 4.6 },
  { Physical_raw_score: 17, Physical_SummedScore: 54.1, Physical_T_Score: 4.7 },
  { Physical_raw_score: 18, Physical_SummedScore: 57.7, Physical_T_Score: 4.9 },
  { Physical_raw_score: 19, Physical_SummedScore: 61.9, Physical_T_Score: 5.2 },
  { Physical_raw_score: 20, Physical_SummedScore: 67.7, Physical_T_Score: 5.9 },
];
